import { store } from "/app/src/store";

export default class Model {
  constructor() {
    this.handleResponse = this.handleResponse.bind(this);
    this.url = this._getUrl.bind(this);
    this.token = this._getToken.bind(this);
    this.state = this._getState.bind(this);
  }

  handleResponse(dispatch) {
    return (err, res) => {
      if (res.statusCode === 200) {
        this._success(dispatch, err, res);
      } else {
        this._failure(dispatch, err, res);
      }
    };
  }

  _getUrl() {
    return store.getState().getIn(["system", "api"]);
  }
  _getToken() {
    return store.getState().getIn(["user", "login", "token"]);
  }
  _getState() {
    return store.getState();
  }
}



// WEBPACK FOOTER //
// src/model/model.js